import React from 'react';

import styles from './ContainerPage.module.scss';

function ContainerPage({ title, children, className = '', globalState }) {
  const { primary } = globalState.getColorScheme();

  return (
    <div className={`${styles.ContainerPage} ${className}`}>
      <div className={styles.ContainerPage__container}>
        {title && (
          <div className={styles.ContainerPage__title}>
            <h2 style={{ borderBottomColor: primary }}>{title}</h2>
          </div>
        )}
        <div className={styles.ContainerPage__body}>{children}</div>
      </div>
    </div>
  );
}

export default ContainerPage;
